import React from 'react'
import { useSelector } from 'react-redux';
import DoughnutChart from '../../components/Charts/DoughnutChart';
import OverAllGraph from '../../components/Charts/OverAllRatingGraph';
import CustomLeftPieGraph from '../../components/Charts/CustomLeftPieGraph';

const Analytics = () => {

  const {
    overAllRating,
    overAllRatingResult,
    feedbackComments,
    feedback1Rating,
    feedback2Rating,
    feedback3Rating,
  } = useSelector((state) => state.adminDashboard);

  const pieData = {
    labels: "",
    datasets: [
      {
        label: "",
        data: [
          Math.round(overAllRatingResult?.ratingsLt3 || 0),
          Math.round(overAllRatingResult?.ratingsGe3 || 0),
        ],
        backgroundColor: ["#FFC0CB", "#1A73E8"],
        borderWidth: 2,
      },
    ],

  }

  return (
    <div className='h-[calc(100%-50px)] flex '>
      <div className='h-full min-w-[300px] p-[24px] flex flex-col gap-[24px] border-r'>
        <h2 className='text-[20px] font-helveticaDisp-Bold text_cus_primary leading-[48px] tracking-[-0.02em] font-[700]'>All Models</h2>
        <div className='flex flex-col gap-[10px]'>
          <div className='flex items-center gap-[8px]'>
            <p className='small-texts text-secondary font-[400] leading-[16px]'>Overall Sentiment:</p>
            <div className='flexCenter gap-[8px]'>
              <div className={`h-[10px] w-[10px] rounded-full ${overAllRatingResult?.percentageGe3 >= 80 ? 'bg-green-500' : 'bg-red-500'}`}></div>
              <p> {overAllRatingResult?.percentageGe3 >= 80 ? 'Positive' : 'Negative'}</p>
            </div>
          </div>
          <div className='flex items-center gap-[8px]'>
            <p className='small-texts text-secondary font-[400] leading-[16px]'>Reviewers:</p>
            <p>{overAllRatingResult?.totalCount}</p>
          </div>
        </div>
        <div className=''>
          {overAllRatingResult?.totalCount === undefined ? (
            // <DataNotFound />
            <div>Data Not Availabel</div>
          ) : (
            <DoughnutChart
              headingRequired={true}
              data={pieData}
              feedbackValues={null}
              value={[Math.floor(overAllRatingResult?.percentageGe3 || 0)]}
              valueRequired={true}
              showUserCounts={false}
            />
          )}
        </div>
      </div>
      <div className='h-full  flex-grow'>
        <OverAllGraph
          title={"Over All Rating"}
          commentsData={feedbackComments}
          graphData={overAllRating}
        />
        <div className='h-[50%] p-[24px] grid grid-cols-3 gap-[24px]'>
          <CustomLeftPieGraph
            graphData={feedback1Rating}
            title={
              "How well did the visualisation inspire you to choose the recommended font?"
            }
          />
          <CustomLeftPieGraph
            graphData={feedback2Rating}
            title={"How well does the font style align with your project idea?"}
          />
          <CustomLeftPieGraph
            graphData={feedback3Rating}
            title={
              "How would you rate the overall quality of the visualisation?"
            }
          />
        </div>
      </div>
    </div>
  )
}

export default Analytics